module.exports = __webpack_public_path__ + "img/icone_icone_2.628a2510.svg";